import { useNavigate } from "react-router-dom";
import Section from "./Section";

type ClientBarProps = {
  action: string;
  client: string;
  url: string;
};

const ClientBar = ({ action, client, url }: ClientBarProps) => {
  const navigate = useNavigate();
  return (
    <div className="border-b">
      <Section
        className="p-4 cursor-pointer group"
        onClick={() => navigate(url)}
      >
        <div className="text-gray-400 text-sm font-bold">{action}</div>
        <div className="truncate text-xl font-bold group-hover:text-gray-300">
          {client ? client : <></>}
        </div>
      </Section>
    </div>
  );
};

export default ClientBar;
